import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Status", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"color":"red"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, " You are registered, ", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, [
  /*#__PURE__*/_createTextVNode("and your application has been successfully submitted."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_9 = {
  key: 0,
  style: {"color":"royalblue"}
}
const _hoisted_10 = {
  key: 1,
  style: {"color":"orangered"}
}
const _hoisted_11 = {
  key: 2,
  style: {"color":"darkred"}
}
const _hoisted_12 = {
  key: 3,
  style: {"color":"green"}
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, " Loading... ", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Application Date:", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Program Applied For:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "First Name:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, "Middle Name:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "Last Name:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "Preferred Name: ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "Suffix:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, "Birth Date:", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("b", null, "SSN:", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "Gender: ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "Ethnicity: ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("b", null, "Medicaid ID:", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "Are you, your spouse or parent a veteran or an active-duty member of the U.S. Military?", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("b", null, "County: ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "Phone Type:", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("b", null, "Phone Number:", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("b", null, "Email Type:", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("b", null, "Email Address:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "Line 1:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("b", null, "Line 2:", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("b", null, "City:", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("b", null, "State:", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", null, "Zip:", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("b", null, "Preferred Method of Contact:", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("b", null, "Are you applying for the Acquired Brain Injury Waiver?", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("b", null, "Name:", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("b", null, "Contact Type:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", null, "Phone Type:", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("b", null, "Phone Number:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", null, "Email Type:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("b", null, "Email Address:", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "Address Type:", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("b", null, "Line 1:", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("b", null, "Line 2:", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("b", null, "City:", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("b", null, "State:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("b", null, "Zip:", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("b", null, "Preferred Method of Contact:", -1)
const _hoisted_59 = { style: {"margin":"5px","padding-left":"10px"} }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("b", null, "Selected Agency:", -1)
const _hoisted_61 = { key: 4 }

import { ref, onMounted } from 'vue';
    import { useAuth0 } from '@/Services/Auth0/auth0-plugin';
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    //import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
    //import router from '@/Router/router'
    import { IParticipantApplication } from '@/Models/IParticipantApplication';
    import { IUser } from '@/Models/IUser'
    import { ParticipantApplicationService } from '@/Services/participant-application-service';
    import { UserService } from '@/Services/user-service';
    import { IPerson } from '../Models/IPerson';
    import { IPersonAddress } from '../Models/IPersonAddress';
    import { IPersonEmail } from '../Models/IPersonEmail';
    import { IPersonPhone } from '../Models/IPersonPhone';
    import { PersonService } from '@/Services/person-service';
    import { PersonAddressService } from '@/Services/person-address-service';
    import { PersonEmailService } from '@/Services/person-email-service';
    import { PersonPhoneService } from '@/Services/person-phone-service';
    import { PersonEmergencyContactService } from '@/Services/person-emergency-contact-service';
    import { IPersonEmergencyContact } from '../Models/IPersonEmergencyContact';
    import { IParticipantApplicationDocument } from '../Models/IParticipantApplicationDocument';
    import { IDocument } from '../Models/IDocument';
    import { ParticipantApplicationDocumentService } from '@/Services/participant-application-document-service';
    import { DocumentService } from '@/Services/document-service';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationStatus',
  setup(__props) {

    const auth0: Auth0 | null = useAuth0();
    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };
    const loadingData = ref(true)

    let statusPending = ref(true);
    let statusDeclined = ref(false);
    let statusAccepted = ref(false);
    let statusMoreInfo = ref(false);
    
    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false
    let hasNoApplication = ref(true)
    let auth0UserId = ref()
    let user = ref<IUser | null>(null);
    let auth0User = ref()
    let existingApp = ref<IParticipantApplication | null>(null)
    let person = ref<IPerson | null>(null)
    let personAddresses = ref<IPersonAddress[] | null>(null)
    let personEmail = ref<IPersonEmail | null>(null)
    let personPhone = ref<IPersonPhone | null>(null)
    let personEmergencyContact = ref<IPersonEmergencyContact | null>(null)
    let participantPortalUserId = ref();
    let participantApplicationCmAgencyDocument = ref<IParticipantApplicationDocument | null>(null)
    let cmAgencyDocument = ref<IDocument | null>(null)
    
    onMounted(async () => {
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                auth0User.value = auth0 ? auth0.user.value : null;
                console.log('Application Status Page is auth0 authenticated: ' + isAuthenticated);
                if (auth0User.value) {
                    auth0UserId.value = auth0User.value.sub; // Access Auth0 user ID
                    //console.log('Auth0 User ID: ' + auth0UserId.value);
                    const r = await UserService.getByAuth0Id(auth0UserId.value);
                    user.value = r;
                    participantPortalUserId.value = user.value.participantPortalUserId;

                    //check if they have an application already
                    const appResult = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = appResult;

                    //console.log("existing app:" + JSON.stringify(existingApp.value, null, 2));
                    if (existingApp.value != null && existingApp.value.participantPortalUserId == participantPortalUserId.value) {
                        //don't let them submit again.
                        hasNoApplication.value = false;
                        //console.log('Application: ' + JSON.stringify(existingApp));
                        switch (existingApp.value.applicationResultId) {
                            case 1:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = true;
                                statusMoreInfo.value = false;
                                break;
                            case 2:
                                statusPending.value = false;
                                statusDeclined.value = true;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                break;
                            case 3:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = true;
                                break;
                            default:
                                statusPending.value = true;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                break;
                        }

                        const personResult = await PersonService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        person.value = personResult;
                        //console.log("Person: " + JSON.stringify(person));
                        const personAddressResult = await PersonAddressService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personAddresses.value = personAddressResult;
                        const personEmailResult = await PersonEmailService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmail.value = personEmailResult;
                        const personPhoneResult = await PersonPhoneService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personPhone.value = personPhoneResult;
                        const personEmergencyContactResult = await PersonEmergencyContactService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmergencyContact.value = personEmergencyContactResult;
                        const participantApplicationDocumentResult = await ParticipantApplicationDocumentService.getByParticipantApplicationId(existingApp.value.participantApplicationId, auth0UserId.value);
                        participantApplicationCmAgencyDocument.value = participantApplicationDocumentResult;
                        console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
                        if (participantApplicationCmAgencyDocument.value.documentId > 0) {
                            const cmAgencyDocumentResult = await DocumentService.getByDocumentId(participantApplicationCmAgencyDocument.value.documentId, existingApp.value.personId, auth0UserId.value);
                            cmAgencyDocument.value = cmAgencyDocumentResult;
                            console.log('document id: ' + cmAgencyDocument.value.documentId);
                            console.log('filename: ' + cmAgencyDocument.value.filename);
                        }

                    } else {
                        hasNoApplication.value = true;
                    }
                    console.log('hasNoApplication: ' + hasNoApplication.value);
                }
            }
        } catch (e) {
            //console.log('Not Authenticated.');
            const errorObj = e as Error;
            console.error('Authentication Error: ' + errorObj.message);
        } finally {
            loadingData.value = false;
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_form, {
      ref: "form",
      style: {"text-align":"left"}
    }, {
      default: _withCtx(() => [
        (loadingData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
          : (_openBlock(), _createBlock(_component_v_container, {
              key: 1,
              density: "compact",
              style: {"max-width":"1024px","text-align":"left","float":"left"}
            }, {
              default: _withCtx(() => [
                (_unref(unregistered))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, [
                        _createTextVNode(" You are currently not registered, or not logged in. You will be unable to track any application submitted through this site unless you are "),
                        _createVNode(_component_router_link, { to: { name: 'register' } }, {
                          default: _withCtx(() => [
                            _createTextVNode("registered")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" and "),
                        _createVNode(_component_router_link, { to: { name: 'login' } }, {
                          default: _withCtx(() => [
                            _createTextVNode("logged in")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(". ")
                      ])
                    ]))
                  : (_unref(registered))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        (!_unref(hasNoApplication))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              _hoisted_8,
                              _createElementVNode("h3", null, [
                                _createTextVNode(" Application Status: "),
                                (_unref(statusPending))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "PENDING"))
                                  : _createCommentVNode("", true),
                                (_unref(statusMoreInfo))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "MORE INFORMATION REQUIRED"))
                                  : _createCommentVNode("", true),
                                (_unref(statusDeclined))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "DECLINED"))
                                  : _createCommentVNode("", true),
                                (_unref(statusAccepted))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "ACCEPTED"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                innerHTML: !_unref(existingApp).applicationResultNote || _unref(existingApp).applicationResultNote.trim() === '' ? '' : '<b>Notes:</b> ' + _unref(existingApp).applicationResultNote + '<br /><br />'
                              }, null, 8, _hoisted_13),
                              _createTextVNode(" Please review submitted information below: ")
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(hasNoApplication))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _createTextVNode("but your application has not yet been submitted."),
                              _hoisted_15,
                              _hoisted_16
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)),
                (!_unref(hasNoApplication))
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 3,
                      style: {"text-align":"left","margin-top":"15px","float":"left","padding":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_20,
                                _createTextVNode(" " + _toDisplayString(new Date((_unref(existingApp)).applicationDate).toLocaleDateString('en-US')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_21,
                                _createTextVNode(" " + _toDisplayString(_unref(existingApp).waiverProgramName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(_unref(person).firstName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_23,
                                _createTextVNode(" " + _toDisplayString(_unref(person).middleName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_24,
                                _createTextVNode(" " + _toDisplayString(_unref(person).lastName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_25,
                                _createTextVNode(" " + _toDisplayString(_unref(person).preferredName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_26,
                                _createTextVNode(" " + _toDisplayString(_unref(person).suffixName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_27,
                                _createTextVNode(" " + _toDisplayString(new Date((_unref(person)).dateOfBirth).toLocaleDateString('en-US')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_28,
                                _createTextVNode(" " + _toDisplayString(_unref(person).ssn), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_29,
                                _createTextVNode(" " + _toDisplayString(_unref(person).genderName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_30,
                                _createTextVNode(" " + _toDisplayString(_unref(person).ethnicityName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_31,
                                _createTextVNode(" " + _toDisplayString(_unref(person).medicaidId), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_32,
                                _createTextVNode(" " + _toDisplayString(_unref(existingApp).isActiveMilitary ? 'Yes' : 'No'), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_33,
                                _createTextVNode(" " + _toDisplayString(_unref(existingApp).countyName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card, {
                          variant: "outlined",
                          title: "Contact Info",
                          class: "text-left",
                          style: {"margin-bottom":"10px","padding":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_34,
                                    _createTextVNode(" " + _toDisplayString(_unref(personPhone).phoneTypeName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_35,
                                    _createTextVNode(" " + _toDisplayString(_unref(personPhone).phoneNumber), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_36,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmail).emailTypeName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_37,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmail).emailAddress), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personAddresses), (personAddress, index) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            key: index,
                            variant: "outlined",
                            title: personAddress.addressTypeName + ' Address',
                            class: "text-left",
                            style: {"margin-bottom":"10px","padding":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _hoisted_38,
                                      _createTextVNode(" " + _toDisplayString(personAddress.addressLine1), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (personAddress.addressLine2)
                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _hoisted_39,
                                          _createTextVNode(" " + _toDisplayString(personAddress.addressLine2), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _hoisted_40,
                                      _createTextVNode(" " + _toDisplayString(personAddress.city), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _hoisted_41,
                                      _createTextVNode(" " + _toDisplayString(personAddress.stateName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _hoisted_42,
                                      _createTextVNode(" " + _toDisplayString(personAddress.zipCode), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                        }), 128)),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_43,
                                _createTextVNode(" " + _toDisplayString(_unref(person).preferredMethodOfContactName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _hoisted_44,
                                _createTextVNode(" " + _toDisplayString(_unref(existingApp).isApplyingForAbi ? 'Yes' : 'No'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_45,
                        _createVNode(_component_v_card, {
                          variant: "outlined",
                          title: "Emergency Contact",
                          class: "text-left",
                          style: {"margin-bottom":"10px","padding":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_46,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).personName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_47,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).contactTypeName), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_48,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).phoneTypeName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_49,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).phoneNumber), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_unref(personEmergencyContact).emailAddress)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _hoisted_50,
                                        _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).emailTypeName), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _hoisted_51,
                                        _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).emailAddress), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_52,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).addressTypeName), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_53,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).addressLine1), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_unref(personEmergencyContact).addressLine2)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _hoisted_54,
                                        _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).addressLine2), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_55,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).city), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_56,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).stateName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_57,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).zipCode), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _hoisted_58,
                                    _createTextVNode(" " + _toDisplayString(_unref(personEmergencyContact).preferredMethodOfContactName), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card, {
                          variant: "outlined",
                          title: "Case Management Agency Selection",
                          class: "text-left",
                          style: {"margin-bottom":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "24",
                                    md: "8"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_60,
                                      _createTextVNode(" " + _toDisplayString(_unref(existingApp).caseManagementAgencyName), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "24",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      (_unref(cmAgencyDocument) && _unref(cmAgencyDocument).documentId && _unref(cmAgencyDocument).documentId > 0)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            color: "primary",
                                            text: "",
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadFile(_unref(cmAgencyDocument).contentBase64, _unref(cmAgencyDocument).filename, 'application/pdf')))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, { left: "" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-download")
                                                ]),
                                                _: 1
                                              }),
                                              _createTextVNode(" " + _toDisplayString(_unref(cmAgencyDocument).filename), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(hasNoApplication))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createTextVNode(" You have not yet submitted an application. Please go to the "),
                      _createVNode(_component_router_link, { to: { name: 'application' } }, {
                        default: _withCtx(() => [
                          _createTextVNode("Participant Application")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" to complete an application. ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})